<mat-form-field appearance="outline">
	<mat-label [attr.aria-label]="'Notiz zur Aufgabe ' + aufgabenTyp()">Notiz zur Aufgabe</mat-label>
	<textarea matInput [formControl]="formGroup.controls.notiz" data-test-id="notiz-input"></textarea>
</mat-form-field>
